/**
 * Help center FAQ types.
 *
 * Content is hand-curated TypeScript today (versioned in this folder).
 * If/when the support team needs to edit without a deploy, port this
 * to a DB-backed table — the shape stays the same so the components
 * don't have to change.
 */

import type { ReactNode } from 'react';

export type HelpCategory =
  | 'getting_started'
  | 'senders'
  | 'contacts'
  | 'sending'
  | 'compliance'
  | 'billing'
  | 'reports'
  | 'troubleshooting'
  // Voice module — added 2026-05-26 with the first customer ship.
  | 'voice'
  | 'ai_agents'
  | 'inbound'
  // Reseller-only categories — entries hidden from customer tenants.
  | 'customers'
  | 'branding'
  // Platform-only.
  | 'platform';

export interface FAQ {
  /** Stable slug — used for #anchor links + analytics. lowercase-kebab. */
  id: string;
  category: HelpCategory;
  question: string;
  /** Rich answer; can include <Link> to portal sections, <code>, lists, etc. */
  answer: ReactNode;
  /** Free-text tags that the search query also matches against. Lowercase. */
  tags?: string[];
  /** Optional in-app deep link the answer references; rendered as a CTA. */
  cta?: { label: string; to: string };
}

export interface CategoryMeta {
  id: HelpCategory;
  /** i18n key used to render the category label in the sidebar. */
  labelKey: string;
}

export const CATEGORIES: CategoryMeta[] = [
  { id: 'getting_started', labelKey: 'help_cat_getting_started' },
  { id: 'senders',         labelKey: 'help_cat_senders' },
  { id: 'contacts',        labelKey: 'help_cat_contacts' },
  { id: 'sending',         labelKey: 'help_cat_sending' },
  { id: 'voice',           labelKey: 'help_cat_voice' },
  { id: 'ai_agents',       labelKey: 'help_cat_ai_agents' },
  { id: 'inbound',         labelKey: 'help_cat_inbound' },
  { id: 'compliance',      labelKey: 'help_cat_compliance' },
  { id: 'billing',         labelKey: 'help_cat_billing' },
  { id: 'reports',         labelKey: 'help_cat_reports' },
  { id: 'troubleshooting', labelKey: 'help_cat_troubleshooting' },
  { id: 'customers',       labelKey: 'help_cat_customers' },
  { id: 'branding',        labelKey: 'help_cat_branding' },
  { id: 'platform',        labelKey: 'help_cat_platform' },
];
